<template>
  <div>
    <div class="maintitle">员工列表</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span="4">
        <el-input v-model='keyword' size="mini" placeholder="请输入搜索关键字" @keyup.enter.native="srch"></el-input>
      </el-col>
      <el-cascader v-model="slctdep" :props="{ checkStrictly: true }" :show-all-levels="false" :options="departmentlist" size='mini' placeholder="请选择部门" class="margin-right" clearable></el-cascader>
        <el-button type="success" size="mini" @click="srch">查找</el-button>
    </el-row>
    <el-table :data="list" row-key="menuid" border>
      <el-table-column prop="account" label="账号"></el-table-column>
      <el-table-column prop="tel" label="电话"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="department_name" label="所在部门"></el-table-column>
      <el-table-column label="状态" :formatter="formatStatus"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type='text' @click="mdfy(scope)">修改</el-button>
          <el-button type='text' class='margin-small-left' @click="resetpswd(scope)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="addDiv" :show-close="false" :close-on-click-modal="false" @opened="initinfo" @closed="resetFormInfo('employeeinfo')">
      <el-form :model="employeeinfo" :rules="rules" ref="employeeinfo">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="employeeinfo.name" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在部门" :label-width="formLabelWidth" class="text-left">
          <div class="block" placeholder='请选择所在部门' clearable>
            <el-cascader v-model="employeeinfo.department" :props="{ checkStrictly: true }" :show-all-levels="false" :options="departmentlist"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="参与考核" class="text-left" prop="needass">
          <el-radio-group v-model="employeeinfo.needass">
            <el-radio-button label="1">参与</el-radio-button>
            <el-radio-button label="0">不参与</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='考核模板' class="text-left" :label-width="formLabelWidth" v-if='employeeinfo.needass == 1'>
          <el-select v-model="employeeinfo.tid" placeholder="请选择考核模板" filterable default-first-option clearable>
            <el-option v-for="(item,index) in templatelist" :key="index" :label="item.department_name?item.name+'('+item.department_name+')':item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='岗位类型' class="text-left" :label-width="formLabelWidth" v-if='employeeinfo.needass == 1'>
          <el-select v-model="employeeinfo.type" placeholder="请选择员工岗位类型" filterable default-first-option clearable @change="typeChange">
            <el-option v-for="(item,index) in employeeTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='评优模板' class="text-left" :label-width="formLabelWidth" v-if='employeeinfo.needass == 1'>
          <el-select v-model="employeeinfo.excellent_tid" placeholder="请选择员工评优模板" filterable default-first-option clearable>
            <el-option v-for="(item,index) in excellentTemplateList" :key="index" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='考核人' class="text-left" :label-width="formLabelWidth" v-if='employeeinfo.needass == 1'>
          <el-select v-model="employeeinfo.ass" placeholder="请选择考核模板" filterable default-first-option clearable remote :remote-method="getEmployeeList" multiple>
            <el-option v-for="(item,index) in allEmployeeList" :key="index" :label="item.department_name?item.name+'('+item.department_name+')':item.name" :value="item.uuid"></el-option>
          </el-select>
          注：如有多个考核人，请按考核顺序添加。如果遵循部门考核人考核，请留空。
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="参与投票" class="text-left" prop="vote" v-if="usergroup==0">
          <el-radio-group v-model="employeeinfo.vote">
            <el-radio-button label="1">参与</el-radio-button>
            <el-radio-button label="0">不参与</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投票部门" :label-width="formLabelWidth" class="text-left" v-if="employeeinfo.vote==1">
          <div class="block" placeholder='请选择可以投票的部门' clearable>
            <el-cascader v-model="employeeinfo.votelist" :props="{ checkStrictly: true,multiple: true }" :show-all-levels="false" :options="departmentlist"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="参与评审" class="text-left" v-if="usergroup===0">
          <el-radio-group v-model="employeeinfo.pingshen">
            <el-radio-button label="1">参与</el-radio-button>
            <el-radio-button label="0">不参与</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :label-width="formLabelWidth" label="状态" class="text-left" prop="status">
          <el-radio-group v-model="employeeinfo.status">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="0">停用</el-radio-button>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item v-if="employeeinfo.uuid==''">
          新用户默认密码：{{dfltpswd}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDiv = false;allEmployeeList=[]">取 消</el-button>
        <el-button type="primary" @click="submdfy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //员工列表
      addDiv: false,
      employeeinfo: {
        uuid: "",
        name:'',
        // status: 1,
        department: '',
        tid: '',
        needass:1,
        vote:0,
        votelist:[[1,3],[1,7,61]],
        ass:'',
        type:1,
        excellent_tid:'',
        pingshen:0
      },
      allEmployeeList:[],
      page: 1,
      total: 0,
      departmentlist: [],
      employeelist: [],
      templatelist: [],
      crntscope: "",
      accounttype: 3,
      dfltpswd: '',
      keyword: '',
      slctdep:'',
      grouplist: [],
      usergroup:'',
      employeeTypeList:[],
      excellentTemplateList:[],
      rules: {
        // title: [
        //   { required: true, message: "请输入菜单名称", trigger: "blur" },
        //   { min: 2, message: "长度不能小于两个汉字", trigger: "blur" }
        // ],
        // model: [{ required: true, message: "请输入模块名称", trigger: "blur" }],
        // controller: [
        //   { required: true, message: "请输入控制器名称", trigger: "blur" }
        // ],
        // action: [{ required: true, message: "请输入方法名称", trigger: "blur" }]
      },
    };
  },
  methods: {
    srch(){
      this.page = 1;
      this.getlist();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/employee/getlist",
        method: "post",
        data: {
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize,
          department:this.slctdep
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
          this.usergroup = res.data.group;
        }
      });
    },
    formatStatus(row, column) {
      return row.needass == 1 ? "参与" : "不参与";
    },
    //重置菜单编辑对话框内容
    resetFormInfo(formName) {
      this.$refs[formName].resetFields();
      this.crntscope = "";
    },
    mdfy(scope) {
      this.crntscope = scope;
      this.addDiv = true;
    },
    initinfo() {
      if (this.crntscope != "") {
        for (let item in this.employeeinfo) {
          this.employeeinfo[item] = this.crntscope.row[item];
        }
        this.getTemplateList(this.employeeinfo.type);
      }
      this.getEmployeeList('aa');
    },
    submdfy() { //console.log(this.employeeinfo);return;
      this.$axios({
        url: this.HOST + "/kaohe/employee/add",
        method: "post",
        data: {
          info: this.employeeinfo
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.addDiv = false;
          this.getlist();
        }
      });
    },
    resetpswd(scope) {
      let uuid = scope.row.uuid;
      this.$confirm(
        "确定要重置" + scope.row.name + "的密码吗？本操作不可恢复",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/employee/resetpswd",
          method: "post",
          data: {
            muuid: uuid,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$alert(
              "用户密码已重置为 " +
              res.data.newpassword +
              " ，请记录后再关闭本对话框，本密码不可重现！",
              "友情提示",
              {
                confirmButtonText: "确定",
              }
            );
          }
        });
      });
    },
    getDepartment() {
      this.$axios({
        url: this.HOST + '/kaohe/index/getCommonInfo',
        method: 'post',
        data: {
          info:['department','employee', 'template','employeeType']
        }
      }).then(res => {
        this.departmentlist = res.data.departmentlist;
        this.dfltpswd = res.data.dfltpswd;
        this.employeelist = res.data.employeelist;
        this.templatelist = res.data.templatelist;
        this.grouplist = res.data.grouplist;
        this.employeeTypeList = res.data.employeeType;
      })
    },
    getEmployeeList(query){
      if(query === '') return [];
      this.$axios({
        url: this.HOST + "/kaohe/employee/getEmployeeList",
        method: "post",
        data:{
          keyword:query,
          ass:this.employeeinfo.ass
        }
      }).then(res=>{
        if (res.data.status === 1) {
          this.allEmployeeList = res.data.list;
        }
      })
    },
    typeChange(){
      this.employeeinfo.excellent_tid = '';
      this.getTemplateList(this.employeeinfo.type)
    },
    getTemplateList(type){
      this.excellentTemplateList = [];
      this.$axios({
        url: this.HOST + "/kaohe/employee/getTemplateList",
        method: "post",
        data:{
          type:type
        }
      }).then(res => {
        if(res.data.status === 1) {
          this.excellentTemplateList = res.data.list;
        }
      })
    }
  },
  created: function () {
    this.getDepartment();
    this.getlist();
  }
};
</script>
<style>
.toplevel {
  width: 100%;
  font-weight: bold;
}
.toplevel > .el-checkbox__label {
  font-size: 16px;
}
</style>